import React, { useState } from 'react';
import { SearchIcon, FilterIcon } from 'lucide-react';
import Avatar from '../components/shared/Avatar';
const DiscoverPage = () => {
  const [activeCategory, setActiveCategory] = useState('recommended');
  const categories = [{
    id: 'recommended',
    name: 'Recommended'
  }, {
    id: 'players',
    name: 'Players'
  }, {
    id: 'coaches',
    name: 'Coaches'
  }, {
    id: 'teams',
    name: 'Teams'
  }, {
    id: 'events',
    name: 'Events'
  }, {
    id: 'scouts',
    name: 'Scouts'
  }];
  const recommendedProfiles = [{
    id: '1',
    name: 'Cristiano Ronaldo',
    username: 'cristiano',
    avatar: 'https://images.unsplash.com/photo-1570295999919-56ceb5ecca61',
    role: 'Player',
    team: 'Al Nassr FC',
    sport: 'football',
    verified: true
  }, {
    id: '2',
    name: 'Serena Williams',
    username: 'serenawilliams',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80',
    role: 'Player',
    team: 'Independent',
    sport: 'tennis',
    verified: true
  }, {
    id: '3',
    name: 'Manchester United',
    username: 'manutd',
    avatar: 'https://images.unsplash.com/photo-1522778119026-d647f0596c20',
    role: 'Club',
    sport: 'football',
    verified: true
  }, {
    id: '4',
    name: 'NBA',
    username: 'nba',
    avatar: 'https://images.unsplash.com/photo-1574623452334-1e0ac2b3ccb4',
    role: 'League',
    sport: 'basketball',
    verified: true
  }];
  const trendingEvents = [{
    id: '1',
    title: 'UEFA Champions League Final',
    image: 'https://images.unsplash.com/photo-1508098682722-e99c43a406b2',
    date: 'Jun 1, 2024',
    location: 'London, UK'
  }, {
    id: '2',
    title: 'NBA All-Star Weekend',
    image: 'https://images.unsplash.com/photo-1504450758481-7338eba7524a',
    date: 'Feb 16-18, 2024',
    location: 'Chicago, USA'
  }];
  const trendingTags = ['#WorldCup2026', '#TransferWindow', '#OlympicGames', '#NBADraft', '#PreSeason'];
  return <div className="bg-white min-h-full pb-16" data-id="element-728">
      {/* Header */}
      <div className="px-4 py-3 border-b border-gray-200" data-id="element-729">
        <h1 className="text-xl font-bold mb-3" data-id="element-730">Discover</h1>
        {/* Search */}
        <div className="flex items-center bg-gray-100 rounded-full px-3 py-2" data-id="element-731">
          <SearchIcon size={18} className="text-gray-500 mr-2" data-id="element-732" />
          <input type="text" placeholder="Search players, teams, events..." className="bg-transparent border-none outline-none text-sm w-full" data-id="element-733" />
          <button data-id="element-734">
            <FilterIcon size={18} className="text-gray-500" data-id="element-735" />
          </button>
        </div>
      </div>
      {/* Categories */}
      <div className="px-2 py-3 overflow-x-auto" data-id="element-736">
        <div className="flex space-x-2" data-id="element-737">
          {categories.map(category => <button key={category.id} className={`px-4 py-1.5 rounded-full text-sm whitespace-nowrap ${activeCategory === category.id ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-800'}`} onClick={() => setActiveCategory(category.id)} data-id="element-738">
              {category.name}
            </button>)}
        </div>
      </div>
      {/* Recommended Profiles */}
      <div className="px-4 py-3" data-id="element-739">
        <div className="flex justify-between items-center mb-3" data-id="element-740">
          <h2 className="font-semibold" data-id="element-741">Recommended for you</h2>
          <button className="text-blue-600 text-sm" data-id="element-742">See all</button>
        </div>
        <div className="space-y-3" data-id="element-743">
          {recommendedProfiles.map(profile => <div key={profile.id} className="flex items-center justify-between" data-id="element-744">
              <div className="flex items-center" data-id="element-745">
                <Avatar src={profile.avatar} size="md" sport={profile.sport} data-id="element-746" />
                <div className="ml-3" data-id="element-747">
                  <div className="flex items-center" data-id="element-748">
                    <span className="font-semibold text-sm" data-id="element-749">
                      {profile.username}
                    </span>
                    {profile.verified && <svg className="w-3 h-3 text-blue-500 ml-1" fill="currentColor" viewBox="0 0 20 20" data-id="element-750">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-751"></path>
                      </svg>}
                  </div>
                  <div className="flex text-xs text-gray-500" data-id="element-752">
                    <span data-id="element-753">{profile.role}</span>
                    {profile.team && <>
                        <span className="mx-1" data-id="element-754">•</span>
                        <span data-id="element-755">{profile.team}</span>
                      </>}
                  </div>
                </div>
              </div>
              <button className="text-blue-600 text-sm font-medium" data-id="element-756">
                Follow
              </button>
            </div>)}
        </div>
      </div>
      {/* Trending Events */}
      <div className="px-4 py-3" data-id="element-757">
        <div className="flex justify-between items-center mb-3" data-id="element-758">
          <h2 className="font-semibold" data-id="element-759">Trending Events</h2>
          <button className="text-blue-600 text-sm" data-id="element-760">See all</button>
        </div>
        <div className="flex space-x-3 overflow-x-auto pb-2" data-id="element-761">
          {trendingEvents.map(event => <div key={event.id} className="min-w-[200px] rounded-lg overflow-hidden border border-gray-200" data-id="element-762">
              <div className="h-24 relative" data-id="element-763">
                <img src={event.image} alt={event.title} className="w-full h-full object-cover" data-id="element-764" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-2" data-id="element-765">
                  <span className="text-white font-medium text-sm" data-id="element-766">
                    {event.title}
                  </span>
                </div>
              </div>
              <div className="p-2" data-id="element-767">
                <div className="flex items-center text-xs text-gray-600" data-id="element-768">
                  <span className="mr-2" data-id="element-769">{event.date}</span>
                  <span data-id="element-770">{event.location}</span>
                </div>
                <button className="mt-2 text-blue-600 text-xs font-medium" data-id="element-771">
                  View details
                </button>
              </div>
            </div>)}
        </div>
      </div>
      {/* Trending Tags */}
      <div className="px-4 py-3" data-id="element-772">
        <h2 className="font-semibold mb-3" data-id="element-773">Trending Tags</h2>
        <div className="flex flex-wrap" data-id="element-774">
          {trendingTags.map((tag, index) => <span key={index} className="bg-gray-100 text-gray-800 rounded-full px-3 py-1.5 text-sm mr-2 mb-2" data-id="element-775">
              {tag}
            </span>)}
        </div>
      </div>
    </div>;
};
export default DiscoverPage;